var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-table", {
        staticClass: "custom-table",
        attrs: { tableClass: "table-bordered", hidePagination: "" },
        scopedSlots: _vm._u([
          {
            key: "thead",
            fn: function() {
              return [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$t("apps.settings.message.application"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.module")))
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.submodule")))
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("span", { staticClass: "mr-2" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t("apps.settings.message.installstatus")
                                ) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "vs-tooltip",
                            {
                              attrs: {
                                text: _vm.$t(
                                  "apps.settings.message.installstatushint"
                                ),
                                position: "top"
                              }
                            },
                            [_c("i", { staticClass: "fas fa-info-circle" })]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.view")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.create")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.update")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.approve")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("apps.settings.message.delete")))
                    ])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "tbody",
            fn: function() {
              return [
                _c(
                  "tbody",
                  _vm._l(_vm.rows, function(row, rowIndex) {
                    return _c("tr", { key: rowIndex }, [
                      row.a.value
                        ? _c("td", { attrs: { rowspan: row.a.rowspan } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "apps.settings.permission.appid" +
                                      row.key.appId
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      row.b.value
                        ? _c("td", { attrs: { rowspan: row.b.rowspan } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "apps.settings.permission." +
                                      _vm.getTranslateKey(row.key, {
                                        isSubModule: false
                                      })
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", { attrs: { rowspan: row.c.rowspan } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              row.c.value
                                ? _vm.$t(
                                    "apps.settings.permission." +
                                      _vm.getTranslateKey(row.key, {
                                        isSubModule: true
                                      })
                                  )
                                : null
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c("i", {
                          class: [
                            "fas fa-cloud-download-alt",
                            row.key.isInstalled ? "text-success" : "text-danger"
                          ],
                          staticStyle: { "font-size": "20px" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        row.action.view
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column justify-content-center align-items-center w-100",
                                staticStyle: { gap: "4px" }
                              },
                              [
                                _c("BaseCheckbox", {
                                  staticStyle: {
                                    position: "relative",
                                    left: "4px"
                                  },
                                  attrs: {
                                    value:
                                      _vm.checkboxs[
                                        _vm.getCheckBoxKey(row.key, "view")
                                      ],
                                    disabled:
                                      _vm.checkboxsDisabled[
                                        _vm.getCheckBoxKey(row.key, "view")
                                      ] || !row.key.isInstalled,
                                    color: "#A3CA76"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleCheckBoxValueChange(
                                        $event,
                                        row.key,
                                        row.action,
                                        "view"
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.getMetadata(
                                  row.key.appId,
                                  row.key.moduleId,
                                  row.key.subModuleId
                                )
                                  ? _c("div", { staticClass: "w-100" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-sm btn-light d-flex flex-column align-items-center w-100",
                                          attrs: {
                                            disabled: !_vm.checkboxs[
                                              _vm.getCheckBoxKey(
                                                row.key,
                                                "view"
                                              )
                                            ]
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.handleClickSettings(
                                                row.key.appId,
                                                row.key.moduleId,
                                                row.key.subModuleId,
                                                _vm.checkboxs[
                                                  _vm.getCheckBoxKey(
                                                    row.key,
                                                    "view"
                                                  )
                                                ],
                                                row.key,
                                                row.action,
                                                "view"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(row.metadata) +
                                              "\n                  "
                                          ),
                                          _c("i", { staticClass: "fas fa-cog" })
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        row.action.create
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center w-100"
                              },
                              [
                                _c("BaseCheckbox", {
                                  staticStyle: {
                                    position: "relative",
                                    left: "4px"
                                  },
                                  attrs: {
                                    value:
                                      _vm.checkboxs[
                                        _vm.getCheckBoxKey(row.key, "create")
                                      ],
                                    disabled:
                                      _vm.checkboxsDisabled[
                                        _vm.getCheckBoxKey(row.key, "create")
                                      ] || !row.key.isInstalled,
                                    color: "#A3CA76"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleCheckBoxValueChange(
                                        $event,
                                        row.key,
                                        row.action,
                                        "create"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        row.action.update
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center w-100"
                              },
                              [
                                _c("BaseCheckbox", {
                                  staticStyle: {
                                    position: "relative",
                                    left: "4px"
                                  },
                                  attrs: {
                                    value:
                                      _vm.checkboxs[
                                        _vm.getCheckBoxKey(row.key, "update")
                                      ],
                                    disabled:
                                      _vm.checkboxsDisabled[
                                        _vm.getCheckBoxKey(row.key, "update")
                                      ] || !row.key.isInstalled,
                                    color: "#A3CA76"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleCheckBoxValueChange(
                                        $event,
                                        row.key,
                                        row.action,
                                        "update"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        row.action.approve
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center w-100"
                              },
                              [
                                _c("BaseCheckbox", {
                                  staticStyle: {
                                    position: "relative",
                                    left: "4px"
                                  },
                                  attrs: {
                                    value:
                                      _vm.checkboxs[
                                        _vm.getCheckBoxKey(row.key, "approve")
                                      ],
                                    disabled:
                                      _vm.checkboxsDisabled[
                                        _vm.getCheckBoxKey(row.key, "approve")
                                      ] || !row.key.isInstalled,
                                    color: "#A3CA76"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleCheckBoxValueChange(
                                        $event,
                                        row.key,
                                        row.action,
                                        "approve"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        row.action.delete
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center w-100"
                              },
                              [
                                _c("BaseCheckbox", {
                                  staticStyle: {
                                    position: "relative",
                                    left: "4px"
                                  },
                                  attrs: {
                                    value:
                                      _vm.checkboxs[
                                        _vm.getCheckBoxKey(row.key, "delete")
                                      ],
                                    disabled:
                                      _vm.checkboxsDisabled[
                                        _vm.getCheckBoxKey(row.key, "delete")
                                      ] || !row.key.isInstalled,
                                    color: "#A3CA76"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.handleCheckBoxValueChange(
                                        $event,
                                        row.key,
                                        row.action,
                                        "delete"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  }),
                  0
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.dataModal.app_id == 8 &&
      _vm.dataModal.module_id == 2 &&
      [1, 2, 3, 4, 5, 6].includes(_vm.dataModal.submodule_id)
        ? _c(
            "BaseModalPermissionSetting",
            {
              attrs: {
                id:
                  "VIEW_APPID" +
                  _vm.dataModal.app_id +
                  "_MODULEID" +
                  _vm.dataModal.module_id +
                  "_SUBMODULEID" +
                  _vm.dataModal.submodule_id,
                "data-modal": _vm.dataModal
              },
              on: {
                onCancel: _vm.handleCancelSettingModal,
                onSubmit: _vm.handleSubmitSettingModal
              }
            },
            [
              _vm.dataModal.metadata
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "form-group col-12 mb-0" },
                      [
                        _c("section-title", { attrs: { title: "การแสดงผล" } }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column",
                            staticStyle: { gap: "6px" }
                          },
                          [
                            _vm.dataModal.metadata.view.fields.cost != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "ต้นทุน" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields.cost,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "cost",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.cost"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataModal.metadata.view.fields.discount != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "ส่วนลด" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields
                                        .discount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "discount",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.discount"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataModal.metadata.view.fields.tax != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "ภาษี" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields.tax,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "tax",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.tax"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataModal.metadata.view.fields.collect != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "ยอดขาย" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields
                                        .collect,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "collect",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.collect"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataModal.metadata.view.fields.refund != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "คืนเงิน" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields.refund,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "refund",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.refund"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataModal.metadata.view.fields.net != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "ยอดขายสิทธิ" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields.net,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "net",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.net"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataModal.metadata.view.fields.profit != null
                              ? _c("BaseCheckbox", {
                                  attrs: { label: "กำไร" },
                                  model: {
                                    value:
                                      _vm.dataModal.metadata.view.fields.profit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataModal.metadata.view.fields,
                                        "profit",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataModal.metadata.view.fields.profit"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b547758", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b547758","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseRolePermission.vue
// module id = null
// module chunks = 